import PARENT from '../types';

const TEST_SELECTION = `${PARENT}/TEST_SELECTION`;

export const SET_TEST_SELECTION = `${TEST_SELECTION}/SET`;

export default TEST_SELECTION;
